import React from "react";
import LcStartImg from "../../assets/images/LcStartImg.png";
import { Button } from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { applicationStore } from "src/store/ApplicationStore";
import { useTranslation } from "react-i18next";
const LivenessCheckStart = observer(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="custom-container">
      <div className="flex justify-between flex-col items-center h-full pt-[10px]">
        <div className="pt-8">
          <div className="">
            <div className="text-h5 font-bold mb-2 text-flow-heading px-12">{t('lc.title')}</div>
            <div className="mt-2 px-3 py-3 text-center z-10 text-Gray900">{t('lc.description')}</div>
          </div>
          <div className="w-[313px] h-[313px]">
            <div className="mt-2">
              <figure className="z-10">
                <img alt="icon" className="w-full" src={LcStartImg} />
              </figure>
            </div>
          </div>
          <div className="items-center py-3 bottom-0">
            <Button
              onClick={() => {
                navigate("/lc", { replace: true });
              }}
              className="mt-1"
              variant="primaryWithoutIcon"
            >
              {t('lc.begin')}
            </Button>
            {window?.top === window?.self && (
              <Button
                onClick={() => {
                  applicationStore.setContinueOnAnotherDevice("/lc-start");
                  navigate("/continue-on-another-device", { replace: true });
                }}
                className="mt-2"
                variant="secondaryWithoutIcon"
              >
                {t('lc.continueAnotherDevice')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default LivenessCheckStart;
